<template>
  <div class="benefits-section">

    <!-- 权益标签页 -->
    <div class="benefits-tabs" v-if="showTabs">
      <!-- <div class="tab-header">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab-item"
          :class="{ active: activeTab === index }"
          @click="activeTab = index"
        >
          <img :src="activeTab === index ? tab.activeIcon : tab.icon" :alt="tab.name" />
        </div>
      </div> -->

      <!-- 图片区域 -->
      <div class="tab-images" v-if="images && images.length > 0">
        <img
          v-for="(img, index) in images"
          :key="index"
          :src="img"
          :alt="`权益说明${index + 1}`"
          class="tab-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitsSection',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeTab: 0,
      defaultTabs: [
        {
          name: '福利一',
          icon: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857102650.png',
          activeIcon: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857106815.png'
        },
        {
          name: '福利二',
          icon: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857111493.png',
          activeIcon: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857114994.png'
        }
      ],
      defaultImages: [
        require('@/assets/images/benefit1.png'),
        require('@/assets/images/benefit2.png')
      ]
    }
  },
  computed: {
    showTabs() {
      return this.config.showTabs !== false
    },
    tabs() {
      return this.config.tabs || this.defaultTabs
    },
    images() {
      return this.config.images || this.defaultImages
    }
  },
  methods: {
    showCallDialog() {
      this.$dialog.confirm({
        title: '提示',
        message: `是否拨打客服电话 ${this.phoneNumber}？`,
        confirmButtonText: '立即拨打',
        cancelButtonText: '再考虑一下'
      }).then(() => {
        window.location.href = `tel:${this.phoneNumber}`
      }).catch(() => {
        // 点击取消，关闭弹框
      })
    }
  }
}
</script>

<style lang="less" scoped>
.benefits-section {
  width: 100%;
  padding: 0.3rem 0.2rem;
}

.benefits-header {
  width: 100%;
  margin-bottom: 0.2rem;
  text-align: center;

  .header-title {
    font-size: 50%;
    font-weight: bold;
    color: #f6f3f3;
    padding: 0.2rem 0;

    .phone-number {
      text-decoration: underline;
      cursor: pointer;
      color: #eeeff0;
    }
  }
}

.benefits-tabs {
  background: transparent;
  border-radius: 0.2rem;
  overflow: hidden;
  margin-bottom: 0.2rem;
}

.tab-header {
  display: flex;
  height: 2rem;
  align-items: center;
  background: transparent;
  

  .tab-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;

    img {
      height: 100%;
      width: 100%;
    }

    // &.active {
    //   background: #fff;
    // }
  }
}

.tab-images {
  width: 100%;
  margin-top: 0.2rem;

  .tab-img {
    width: 100%;
    height: auto;
    display: block;
    margin-bottom: 0.5rem;
    border-radius: 0.1rem;
  }
}

.tab-content {
  padding: 0.3rem;
}

.benefit-panel {
  animation: fadeIn 0.3s ease;
}

.benefit-card {
  background: linear-gradient(135deg, #FFF5F5 0%, #FFFFFF 100%);
  border-radius: 0.2rem;
  padding: 0.3rem;
  border: 1px solid #FFE5E5;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  margin-bottom: 0.2rem;

  .tag {
    background: #E7401E;
    color: #fff;
    font-size: 0.22rem;
    padding: 0.05rem 0.15rem;
    border-radius: 0.1rem;
  }

  .title {
    font-size: 0.32rem;
    font-weight: 600;
    color: #333;
  }
}

.card-content {
  .amount {
    font-size: 0.72rem;
    font-weight: bold;
    color: #E7401E;
    text-align: center;
    margin: 0.2rem 0;

    .unit {
      font-size: 0.36rem;
    }
  }

  .desc {
    font-size: 0.28rem;
    color: #333;
    text-align: center;
    margin-bottom: 0.1rem;
  }

  .sub-desc {
    font-size: 0.24rem;
    color: #999;
    text-align: center;
  }
}

.member-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.2rem;
  margin: 0.2rem 0;
}

.member-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.15rem;
  background: #fff;
  border-radius: 0.1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .member-icon {
    font-size: 0.4rem;
    margin-bottom: 0.08rem;
  }

  .member-name {
    font-size: 0.2rem;
    color: #666;
    text-align: center;
  }
}

.member-notice {
  font-size: 0.24rem;
  color: #E7401E;
  text-align: center;
  margin-top: 0.2rem;
  padding: 0.15rem;
  background: #FFF5F5;
  border-radius: 0.1rem;
}

.benefits-images {
  .benefit-img {
    width: 100%;
    height: auto;
    display: block;
    margin-bottom: 0.2rem;
    border-radius: 0.1rem;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(0.1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
